import React, { useEffect, useRef, useState } from "react";
import UserLogin from "./users/login";
import { useRouter } from "next/router";
import { getLocalStorageUser } from "src/helpers/api/sharedFunction";
import {
  captureCmsParamsFromQuery,
  getCmsSubscriptionRedirectPath,
  getPlanIdFromQuery,
  urlHasCmsPlaintextParams,
} from "src/helpers/coupon-client";

const Home = () => {
  const router = useRouter();
  const [isClient, setIsClient] = useState(false);
  const cmsCaptureLock = useRef(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsClient(true);
  }, []);

  // Capture CMS plan/coupon into storage, then strip them from the URL (no API).
  useEffect(() => {
    if (!isClient || !router.isReady || cmsCaptureLock.current) return;
    if (!getPlanIdFromQuery(router.query)) return;

    cmsCaptureLock.current = true;
    captureCmsParamsFromQuery(router.query, "/");
    if (urlHasCmsPlaintextParams(router.asPath, router.query)) {
      void router.replace("/", undefined, { shallow: true });
    }
  }, [isClient, router.isReady, router.query, router]);

  useEffect(() => {
    if (!isClient || !router.isReady) return;

    const user = getLocalStorageUser();
    const path = router.asPath;
    if (user) {
      if (
        !user.is_subscribed &&
        !user.is_free &&
        !["/profile", "/subscription", "/subscription/payment-gateway"].some(
          (p) => path.startsWith(p),
        )
      ) {
        const cmsPath = getCmsSubscriptionRedirectPath();
        router.push(cmsPath || "/subscription");
      } else {
        router.push("/dashboard");
      }
    }
  }, [isClient, router]);

  if (!isClient) return null;

  if (!localStorage.getItem("admin") && !localStorage.getItem("BetaUser")) {
    return <UserLogin />;
  }

  return null;
};

export default React.memo(Home);
